export default __webpack_public_path__ + "static/media/img-0382-switzerland-full-face.55e9925d.png";